<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/community_manager/wip"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Wip</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/designer/wip"
      *ngIf="role=='designer'">Wip</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']"
      [queryParams]="{lead_status: lead_status}"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager' || role=='sales_manager' || role=='area_sales_manager')">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']"
      [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead </span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;"
      *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}} -
      {{lead_details.project_details.name}}</span>
  </div>
</div>
<div class="rk-ui-notification"  *ngIf="successalert" style="z-index: 10000 !important">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err"  *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status'
    [payment_tab]='"active"'></app-shared-top-menu>
  <div class="col-12">
    <div class="row mb-5">
      <div class="col-md-12 bg-white pb-3">
        <!-- Amount Details -->
        <div class="row">
        <div class="col-md-4 mt-3">
        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Order Pipeline Date : </span>
          <span class="mb-0">{{orderPipeLineDate | date:'dd/MM/yyyy'}}</span>
        </div>
        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Order Booking Actual Date : </span>
          <span class="mb-0">{{order_booking_actual | date:'dd/MM/yyyy'}}</span>
        </div>

        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Order Confirmation Actual Date : </span>
          <span class="text-center mb-0">{{order_confirmation_actual | date:'dd/MM/yyyy'}}</span>
        </div>

        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Estimated Handover Date : </span>
          <span class="text-center mb-0">{{estimated_handover | date:'dd/MM/yyyy'}}</span>
        </div>
        </div>
        <div class="col-md-8">
        <div class="d-flex mt-3">
          <div class="amoutDetailsCard pt-1 text-center">
            <p class="mb-0">Total Approved Amount : </p>
            <p class="text-center mb-0">₹{{unutilized_amount | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 10% : </p>
            <p class="text-center mb-0">₹{{amountAdded_10 | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 40% : </p>
            <p class="text-center mb-0">₹{{amountAdded_40 | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 50% : </p>
            <p class="text-center mb-0">₹{{amountAdded_40 | number : '1.0-0'}}</p>
          </div>
        </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ul class="nav nav-tabs ss-nav-tabs same-line" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active addCursor text-center "  (click)="getSet('pre_10_percent')"
                  [ngClass]="{'active': selectedSet == 'pre_10_percent'}">Initial Payment</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active addCursor text-center"  (click) = "getSet('order_pipe')"
                [ngClass]="{'active': selectedSet == 'order_pipe'}">Order Pipeline</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active addCursor text-center" (click)="getSet('10_50_percent')"
                  [ngClass]="{'active': selectedSet == '10_50_percent'}">40% + 10% Payment</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active addCursor text-center"  (click)="getSet('100_percent')"
                  [ngClass]="{'active': selectedSet == '100_percent'}">Final 50% Payment</a>
              </li>
            </ul>
          </div>

          <div class="col-md-6 marginTop39px">
            <!-- <button
              *ngIf="role == 'designer' || role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'"
              type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#paymentMapping"
              (click)="openPaymentMappingModal()">Map Paymentss</button> -->



              <!-- [disabled] = "!disableButtonForPayment" -->
              <!-- <span *ngIf="approvedBoqList.length == 0">Add Payment</span><span *ngIf="approvedBoqList.length > 0 ">Send Payment Link</span>  -->

            <!-- Add payment link button -->
            <ng-container *ngIf ="selectedSet == 'pre_10_percent' || selectedSet == 'order_pipe' || selectedSet == '10_50_percent' || selectedSet == '100_percent'  ">
              <button [disabled] = "!disableButtonForPayment"   *ngIf="(role == 'designer' || role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager' || role=='sales_manager' || role=='area_sales_manager' || role=='deputy_general_manager') && approvedBoqList"
              type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#addPayment"
                (click)="getNewFetchDetails()">
                <span>Add Payment</span>
              </button>
            </ng-container>

              
            <button type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#paymentHistoryModal"
              (click)="getPaymentHistory()">Payment History </button>
              <button type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#accountDetailsModal"
              (click)="getAccountDetails()">Account Details</button>
              <button class="  bt-boq-3 btn align"  (click) = "jubrun()" >Run Job</button>
          </div>
        </div>

        <!-- <div class="row justify-content-end">
          <div class="col-6">
            <button class="mt-2  bt-boq-3 btn align"  (click) = "jubrun()" >Run Job</button>
            <button class="mt-2 px-5" style="background-color: #8d0528; color: white; border: none; border-radius: 5px;" (click) = "jubrunFortyApprove()" >forty Approve job</button>
            <button class="mt-2  bt-boq-3 btn"  (click) = "jubrunFortyRemainderjob()" >Forty Reminder Job</button>
          </div>
        </div> -->
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="tableDiv " *ngIf="approveList && approveList.length>0">
              <div class="table-responsive">
                <table class="table ">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" class="firstTh">#</th>
                      <th scope="col">REFERENCE NUMBER</th>
                      <th scope="col">FINAL BOQ Value</th>
                      <th scope="col">PAID AMOUNT</th>
                      <th scope="col">BALANCE AMOUNT</th>
                      <th scope="col">PAYMENT</th>
                      <th *ngIf ="selectedSet === '10_50_percent' || selectedSet === '100_percent'"  scope="col">UNMAP</th>
                      <th class="">
                        <span *ngIf="selectedSet == 'pre_10_percent'">
                          ORDER PIPELINE
                        </span>

                        <span *ngIf="selectedSet == 'order_pipe'">
                          ORDER PIPELINE
                        </span>

                        <span *ngIf="selectedSet == '10_50_percent'">
                          PUSH TO PRODUCTION
                        </span>

                        <span *ngIf="selectedSet == '100_percent'">
                          FINAL PAYMENT COMPLETION
                        </span>

                      </th>
                      <th *ngIf ="selectedSet === 'pre_10_percent' || selectedSet === 'order_pipe'" >
                        REPORT CLOSURE
                      </th>
                      <!-- for testing purpose -->
                      <th *ngIf ="selectedSet === '10_50_percent'">Hold / Un-Hold</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let quotation of approveList; let i = index; " [attr.data-index]="i" class="box-list">
                      <!-- # -->
                      <td>{{ i +1 }}</td>    
                       <!-- reference number  with checkbox -->
                      <td >


                        <span id="tenpercent" style="position: absolute; left: 54px;margin-top: 1px;" *ngIf="selectedSet == 'pre_10_percent'">
                         <input *ngIf ="quotation.per_10_approved_at == null" (click) ="sendQuoationId(quotation.id , i, quotation.total_amount,  $event,quotation.wip_status)" type="checkbox" id= "quotation{{i}}">
                        </span>

                        <span id="fortpercent" style="position: absolute; left: 48px;margin-top: 1px" *ngIf="selectedSet == '10_50_percent' && quotation.per_50_approved_at == null && quotation.onhold_resume_at == null && !quotation.onhold  && quotation.bh_p2p == null ">
                          <input (click) ="sendQuoationId(quotation.id , i, quotation.total_amount,$event,quotation.wip_status)" type="checkbox" id= "quotation{{i}}">
                        </span>

                        <span id="order_pipe" style="position: absolute; left: 48px;margin-top: 1px" *ngIf="selectedSet == 'order_pipe'">
                          <input *ngIf ="quotation.per_10_approved_at == null"  (click) ="sendQuoationId(quotation.id , i, quotation.total_amount,  $event,quotation.wip_status)" type="checkbox" id= "quotation{{i}}">
                        </span>

                        <span id="hunderedpercent" style="position: absolute; left: 50px;margin-top: 1px" *ngIf="selectedSet == '100_percent'">
                          <input *ngIf ="quotation.per_100_approved_at == null && !(quotation.paid_amount/(quotation.total_amount)*100 >= 99.9)"   (click) ="sendQuoationId(quotation.id , i, quotation.total_amount,  $event,quotation.wip_status)" type="checkbox" id= "quotation{{i}}">
                        </span>
                        <a [routerLink]="['/lead/'+lead_id+'/project/'+project_id+'/boq_modular/'+quotation.id]"
                         [ngClass] = "setColoronhold(quotation.onhold, quotation.per_50_approved_at ,selectedSet)" routerLinkActive='active'>{{quotation.reference_number}}
                        </a>
                        <span (click) = "onHoldDetailsModal(quotation)" *ngIf ="quotation.onhold && quotation.per_50_approved_at == null && selectedSet =='10_50_percent' "  class="fa fa-info-circle pop cursor-pointer"></span>
                      </td>
                      <!-- final boq value -->
                      <td>₹ {{ quotation.total_amount  |  number : '1.0-0'}}</td>
                      <!-- paid amount -->
                      <td>
                        <span
                          *ngIf="quotation.paid_amount != null">₹ {{ quotation.paid_amount |  number : '1.0-0' }}</span>
                        <span *ngIf="quotation.paid_amount == null">0</span>
                      </td>
                      <!-- balance amount -->
                      <td>₹ {{ (quotation.total_amount - quotation.paid_amount)|  number : '1.0-0' }}</td>
                      <!-- payment (calculating percentage) -->
                      <td>
                        <div class="d-flex"
                          *ngIf="quotation.closure_status != 'completed' && (selectedSet == 'pre_10_percent' || selectedSet == '10_50_percent' || selectedSet == 'order_pipe' )">
                          <div class="paidPercentageBlock mr-2">
                            {{ ((quotation.paid_amount/quotation.total_amount)*100) |  number : '1.2-2' }}%</div>
                        </div>

                        <div class="d-flex"
                          *ngIf="quotation.closure_status != 'completed' && selectedSet == '100_percent'">
                          <div class="paidPercentageBlock mr-2">
                            {{ ((quotation.paid_amount/quotation.total_amount)*100) |  number : '1.2-2' }}%</div> 
                        </div>
                      </td>
                      <!-- un map  -->
                      <td *ngIf ="selectedSet === '10_50_percent' || selectedSet === '100_percent'" >
                        <span class="cursor-pointer" title="Unmap"
                        *ngIf="quotation.per_10_closure_reported_at == null && quotation.per_10_approved_at ==  null && quotation.paid_amount != null && selectedSet == 'pre_10_percent' "
                        (click)="cancelMapping(quotation.id)">
                        <i class="fa fa-ban text-danger"
                          style="font-size:24px"></i>
                        </span>
                       
                          <span class="cursor-pointer" title="Unmap"
                            *ngIf="quotation.per_50_approved_at ==  null && selectedSet == '10_50_percent' && quotation.bh_p2p == null "
                            (click)="cancelMapping(quotation.id)">
                            <i class="fa fa-ban text-danger"
                              style="font-size:24px"></i>
                          </span>
                          <span title="Unmap" class="cursor-pointer" *ngIf="quotation.per_100_reported_at ==  null && selectedSet == '100_percent'"
                              (click)="cancelMapping(quotation.id)" class="pointerCurser">
                              <i class="fa fa-ban text-danger"
                                style="font-size:24px"></i>
                          </span>
                      </td>
                      <!-- ORDER PIPELINE -->
                      <td>
                        <ng-container *ngIf="selectedSet == 'pre_10_percent'">
                          <ng-container *ngIf="role!='business_head'">

                               <span
                              *ngIf= "quotation.order_pipeline_status !== null && quotation.order_pipeline_status  ===  'Pending' "
                              data-toggle="modal" data-target="#closureModal" (click)="openClosureModal(quotation.id)"
                              class="pointerCurser closure_icon pb-2 pointerCurser pt-2 text-center bt-boq-final2 d-block">
                              Report Order Pipeline
                            </span>
                            <span *ngIf= "quotation.order_pipeline_status !== null && quotation.order_pipeline_status  ===  'Reported' " class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                                BU Head to Action
                            </span>
                          </ng-container>

                          <!-- <span *ngIf="quotation.per_10_approved_at !=  null &&  quotation.order_pipeline_status === null ">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span> -->

      
                          <span data-toggle="modal" data-target="#ApproveOrderPipeLineModel" id="534534" *ngIf = "quotation.order_pipeline_status !== null &&  (role=='city_gm' || role == 'business_head') &&  quotation.order_pipeline_status === 'Reported'" 
                          (click)="openClosureModal(quotation.id)" class="bt-boq-final2 pointerCurser text-center mr-2 py-2 d-block">Approve Order PipeLine</span>
                          <span data-toggle="modal" data-target="#closureModal" id="6456546" *ngIf = "quotation.order_pipeline_status !== null &&  (role=='city_gm' || role == 'business_head') &&  quotation.order_pipeline_status === 'Pending' " 
                          (click)="openClosureModal(quotation.id)" class="bt-boq-final2 pointerCurser text-center mr-2 py-2 d-block">Report Order PipeLine</span>
                        </ng-container>

                        <ng-container *ngIf ="selectedSet == 'order_pipe' ">
                          <span *ngIf="quotation.per_10_approved_at !=  null">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span>
                        </ng-container>

                        <ng-container *ngIf="selectedSet == '10_50_percent'">
                          <!-- <span
                            *ngIf="quotation.per_50_push_to_production_reported_at == null && quotation.per_50_approved_at == null"
                            data-toggle="modal" data-target="#reqpushToprobModal"
                            (click)="openpushToproduction(quotation.id)" class="pb-2 pointerCurser pt-2 text-center bt-boq-final2">
                              Push to Production
                            </span>
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role == 'business_head')"
                            (click)="approvePushtoProduction(quotation.id)" class="bt-boq-success pb-1 pointerCurser pt-1 text-center mr-2">
                            Approve pushed to production
                          </span>
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role == 'business_head')"
                            (click)="rejectPushtoProduction(quotation.id)" class="bt-boq pb-1 pointerCurser pt-1 text-center" style="background-color: red !important; border-radius: 6px;">
                            Reject pushed to production
                          </span>

                          <span *ngIf="quotation.per_50_approved_at != null">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span>

                          <span *ngIf="quotation.aide_restore_flag" data-toggle="modal" data-target="#pushToprodModal"  (click)="openpushToProdModal(quotation)">
                            <i class="fa fa fa-check-circle text-success ml-5" style="font-size:24px"></i>
                          </span>

                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role != 'business_head')" class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                            BU Head to Action
                          </span> -->

                          <div class="ml-5 " *ngIf="quotation.per_50_approved_at != null">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </div>
  
                          <div class="ml-5" *ngIf="quotation.aide_restore_flag" data-toggle="modal" data-target="#pushToprodModal"  (click)="openpushToProdModal(quotation)">
                            <i class="fa fa fa-check-circle text-success ml-5" style="font-size:24px"></i>
                          </div>

                          <span *ngIf ="selectedSet === '10_50_percent' && !quotation.onhold  && quotation.per_50_approved_at === null && quotation.bh_p2p == null">
                            <button class="btn text-white cursor-pointer" style="background-color: #8d0528; padding: 0.5rem 0.25rem;" data-toggle="modal" data-target="#confirmP2P" (click)="PtoP(quotation.id)" >Push To Production</button>
                          </span>

                          <ng-container *ngIf="role == 'business_head'"> 

                            <div class="d-flex w-100">

                              <div class="d-flex w-100">
                                <span *ngIf="quotation.bh_p2p == 'pending'"
                         
                              class="bt-boq-success pb-1 pointerCurser col-6 pt-1 text-center mr-2 d-inline-block" data-toggle="modal" (click)="PtoP(quotation.id)" data-target="#confirmP2PApprove">
                              Approve<br>
                              Push to Production
                            </span>
    
                            <span *ngIf="quotation.bh_p2p == 'pending'"
                            (click)="reject40PaymentSelection(quotation.id)"
                               class="bt-boq-reject2 pb-1 pointerCurser pt-1 col-6 text-center d-inline-block"  (click)="PtoP(quotation.id)"  >
                              Reject <br>  Push to Production
                            </span>

                              </div>
                              

                            </div>
                           
                        </ng-container>
                          <ng-container *ngIf="role != 'business_head'">
                          
                          <span *ngIf="quotation.bh_p2p == 'pending'" 
                          class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                          <!-- <i
                            class="fa fa-warning text-danger" style="font-size:24px"></i> -->
                          BU Head to Action
                          </span>
  
                          

                          </ng-container>

                         


                      </ng-container>


                      <!-- final payment completion start-->

                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <span
                            *ngIf="quotation.per_100_reported_at == null && quotation.per_100_approved_at == null"
                            data-toggle="modal" data-target="#finalpaymentselectionModel"
                            (click)="openFinalPaymentSelection(quotation.id)" class="pb-1 pointerCurser pt-1 text-center bt-boq-final d-block" style="width: 178px !important;">
                            <!-- <i class="fas fa-certificate"></i> -->
                            <!-- <i class="fas fa-certificate"
                              style="font-size:24px"></i> -->
                            Final Payment Completion Confirmation
                            </span>
                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role == 'business_head')"
                            (click)="approveFinalPaymentSelection(quotation.id)" class="bt-boq-success pb-1 pointerCurser pt-1 text-center mr-2 d-inline-block">
                            Approve Final Payment Completion
                          </span>

                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role == 'business_head')"
                            (click)="rejectFinalPaymentSelection(quotation.id)" class="bt-boq-reject2 pb-1 pointerCurser pt-1 text-center d-inline-block">
                            Reject Final Payment Completion
                          </span>

                          <div class="afterapproval d-flex"  *ngIf="quotation.per_100_approved_at != null">
                          <span class="mr-5">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span>
                          <span  *ngIf="(role == 'business_head')"
                          (click)="openFinalPaymentSelection(quotation.id)" data-toggle="modal" data-target="#confirmRevert"
                            class="bt-boq-final pointerCurser text-center text-light py-2 bt-boq" style="width:100px; color: #8d0528;" >
                            Revert
                          </span>
                          </div>

                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role != 'business_head')" class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                            <!-- <i
                              class="fa fa-warning text-danger" style="font-size:24px"></i> -->
                            BU Head to Action
                            </span>
                        </ng-container>
                      </td>
                      <td class="text-center" *ngIf ="selectedSet === '10_50_percent'">
                        <span  *ngIf="quotation.per_50_approved_at == null  && quotation.bh_p2p == null">
                          <span title="Un-Hold" *ngIf="quotation.onhold" (click) = "puttheBOQONHold(quotation.id,'unhold',quotation.reference_number)">
                            <img class="cursor-pointer" src="../../../../assets/img/fortypercentgreen.png">
                          </span>
                          <span title="Hold" (click) = "puttheBOQONHold(quotation.id, 'hold',quotation.reference_number)">
                            <img class=" cursor-pointer "  src="../../../../assets/img/fortypercentred.png">  
                          </span>
                        </span>
                      </td>
                      <!--Report closure  -->
                      <td *ngIf ="selectedSet === 'pre_10_percent' || selectedSet === 'order_pipe'" >
                        <ng-container *ngIf="role =='business_head'">
                          <span *ngIf="shouldShowReportClosureButton(quotation.id)"
                           data-toggle="modal" data-target="#ReportClouser" (click)="openClosureModal(quotation.id)"
                           class="pointerCurser closure_icon pb-2 pointerCurser pt-2 text-center bt-boq-final2 d-block">
                           Report Closure
                          </span>
                        </ng-container>
                        <span *ngIf="shouldShowReportClosureButton(quotation.id) == false">
                          <i class="fa fa-check text-success" style="font-size:24px"></i>
                        </span>

                      </td>
                    </tr>
                    <tr>
                      <td></td>
                        <td><b>Total</b></td>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{total_amunt_sum | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{total_sum_50 | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{paid_amunt_sum | number : '1.0-0'}}</b></td>
                      </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{paid_sum_50 | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{(total_amunt_sum - paid_amunt_sum) | number : '1.0-0'}}</b></td>
                      </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{(total_sum_50 - paid_sum_50) | number : '1.0-0'}}</b></td>
                        </ng-container>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-12 not-found " *ngIf="approveList && approveList.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!-- Modal create for payment -->
<div id="addPayment" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog  modal-lg" style="max-width:50% ;">
    <div class="modal-content  paymodal-change" >
      <div class="modal-header  paymodal-header-change">
        <h4 *ngIf="approvedBoqList.length == 0" class="modal-title pay-modal-title-change" style="width: 100%;margin-left: 24px;">Add Payment Details</h4>
         <h4 *ngIf=" approvedBoqList.length > 0 " class="modal-title pay-modal-title-change" style="width: 100%;margin-left: 24px;;">Add Payment Details</h4>
        <div class="payiconbox">
          <button type="button" class="close close-icon" data-dismiss="modal" (click)="paymentReset()">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change pay-modal-change-body" >
        <ul class="nav nav-tabs ul-payment " role="tablist" >
          <li  class="nav-item pay-tabs  " style="width: 50%;">
            <a class="nav-link pay-tabs pay-tabs-base " [ngClass]="{
                              'active':
                                approvedBoqList.length == 0
                            }"  data-toggle="tab" href="#addpayment" role="tab">
              <i class="now-ui-icons objects_umbrella-13"></i>  Payment Through Cheque
            </a>
          </li>
          <li class="nav-item pay-tabs " style="width: 50%;">
            <a class="nav-link pay-tabs pay-tabs-base"  [ngClass]="{
                              'active':
                                 approvedBoqList.length > 0 
                            }" data-toggle="tab" href="#profile" role="tab">
              <i class="now-ui-icons shopping_cart-simple"></i> Send Payment Link / Map Payment
            </a>
          </li>
        </ul>
        <div class="tab-content  mt-3 "   style="padding-right: 20px;padding-left: 20px;">

          <!-- Payment Through Cheque -->
          <div class="tab-pane"  [ngClass]="{
            'active':
                approvedBoqList.length == 0
          }" id="addpayment" role="tabpanel">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="paymentForm">
              <ng-container *ngIf="selectedSet != '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Enter Paid Amount"
                  formControlName="amount">
              </ng-container>
              <ng-container *ngIf="selectedSet == '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Paid Amount"
                  formControlName="amount" (input)="checkPendingAmt($event.target.id)">
              </ng-container>

              <select formControlName="mode_of_payment" class="form-control mb-2 d-none" (change)="changePaymentMode($event)">
                <option [selected]="true" value="cheque">Cheque</option>
              </select>

              <input type="text" class="form-control mb-2" placeholder="Bank Name" formControlName="bank">
              <input type="number" class="form-control mb-2" placeholder="Cheque Number" formControlName="cheque_number">
              <input type="text" class="form-control mb-2" placeholder="Branch Name" formControlName="branch">
              <label class="">Date of cheque</label>
              <input type="date" class="form-control mb-2" formControlName="date_of_checque">
              <label class="">Upload Image*</label>
              <input type="file" class="form-control" formControlName="image" (change)="onChange($event)">
              <!-- <input type="file" class="form-control d-none" formControlName="quotations_ids"> -->
             
              <label class="neft-mode">Payment Date</label>
              <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" (click)="savePayment()" [disabled]="!paymentForm.valid || (!basefile) ">Add Payment</button>
            </form>
            <pre>
            <!-- {{paymentForm.value | json}} -->
          </pre>
        </div>
          <div class="col-md-6">
          </div>
        </div>
          </div>
          <!-- Send Payment Link -->
          <div class="tab-pane" [ngClass]="{
                              'active':
                               approvedBoqList.length > 0 
                            }" id="profile" role="tabpanel">
            <div class="row">
              <div class="col-md-12">
            <form [formGroup]="sendpaymentForm" >
              <label >Enter Amount</label>
              <div class="input-group">
                <input  [readonly]="!toggleInputField"  type="text" class="form-control mb-2" placeholder="Enter amount" formControlName="totalamount" appTwoDigitDecimaNumber [(ngModel)] ="totalAmount" onKeyPress="totalamount()" >
                <div class="input-group-append">
                    <i (click) = "enableTheForm()" style="color: #8d0528; position: absolute; top: 20% ; right: 2%; z-index: 99999999;" class="fa fa-pencil cursor-pointer"></i>
                </div>
              </div>
              <p class="error" *ngIf="messeageFortenk">{{displaymessageFortenk}}</p>
              <label >Email</label>
              <input type="text" class="form-control mb-2 " formControlName="email" [(ngModel)]="LeadNumber">
              <p class="error" *ngIf="sendpaymentForm.controls.email.touched && sendpaymentForm.controls.email.errors && sendpaymentForm.controls.email.errors.pattern">Please enter valid Email Address</p>
              <label >Mobile Number</label>
              <input type="number" class="form-control mb-2 " formControlName="mobilenumber" [(ngModel)]="LeadMail"  onKeyPress="if(this.value.length==10) return false;" >
              <p class="error" *ngIf="sendpaymentForm.controls.mobilenumber.touched && sendpaymentForm.controls.mobilenumber.errors && sendpaymentForm.controls.mobilenumber.errors.pattern">Mobile number should be 10 digit</p>
                <button id="for_ten_percent" *ngIf="selectedSet == 'pre_10_percent' || selectedSet == 'order_pipe' " class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" [disabled]="!sendpaymentForm.valid" (click)="sendapaymentrequest(sendpaymentForm.value)">Send Payment Link / Map Payment</button>
                <button id="for_forty_percent" *ngIf="selectedSet == '10_50_percent'" class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" [disabled]="!sendpaymentForm.valid" (click)="sendapaymentrequest_forty(sendpaymentForm.value)">Send Payment Link / Map Payment</button>
                <button id="for_hundered_percent" *ngIf="selectedSet == '100_percent'" class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" [disabled]="!sendpaymentForm.valid" (click) = "sendapaymentrequest_Hundered(sendpaymentForm.value)"  >Send Payment Link / Map Payment</button>
            </form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="addPaymentTenHundered" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog  modal-lg" style="max-width:50% ;">
    <div class="modal-content  paymodal-change" >
      <div class="modal-header  paymodal-header-change">
        <h4 *ngIf="approvedBoqList.length == 0" class="modal-title pay-modal-title-change" style="width: 100%;margin-left: 24px;">Add Payment Details</h4>
         <h4 *ngIf=" approvedBoqList.length > 0 " class="modal-title pay-modal-title-change" style="width: 100%;margin-left: 24px;;">Add Payment Details</h4>
        <div class="payiconbox">
          <button type="button" class="close close-icon" data-dismiss="modal" (click)="paymentReset()">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change pay-modal-change-body" >
        <ul class="nav nav-tabs ul-payment " role="tablist" >
          <li *ngIf="approvedBoqList.length == 0" class="nav-item pay-tabs  " style="width: 50%;">
            <a class="nav-link pay-tabs pay-tabs-base " [ngClass]="{
                              'active':
                                approvedBoqList.length == 0
                            }"  data-toggle="tab" href="#addpayment_forty_hundered" role="tab_one">
              <i class="now-ui-icons objects_umbrella-13"></i> Add Payment
            </a>
          </li>
          <li class="nav-item pay-tabs " style="width: 50%;" [ngClass] ="{'w-100':approvedBoqList.length > 0 }"
          >
            <a class="nav-link pay-tabs pay-tabs-base"  [ngClass]="{
                              'active':
                                 approvedBoqList.length > 0 
                            }" data-toggle="tab" href="#profileFortyHundered" role="tab_two">
              <i class="now-ui-icons shopping_cart-simple"></i> Send Payment Link / Map Payment
            </a>
          </li>
        </ul>
        <div class="tab-content  mt-3 "   style="padding-right: 20px;padding-left: 20px;">
          <div class="tab-pane" *ngIf="approvedBoqList.length == 0" [ngClass]="{
                              'active':
                                 approvedBoqList.length == 0
                            }" id="addpayment_forty_hundered" role="tab_one">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="paymentForm">
              <ng-container *ngIf="selectedSet != '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Enter Paid Amount"
                  formControlName="amount">
              </ng-container>
              <ng-container *ngIf="selectedSet == '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Paid Amount"
                  formControlName="amount" (input)="checkPendingAmt($event.target.id)">
              </ng-container>

              <select formControlName="mode_of_payment" class="form-control mb-2" (change)="changePaymentMode($event)">
                <option value="" [selected]="true" disabled="true">Select Payment Mode</option>
                <option value="NEFT/RTGS">NEFT/RTGS</option>
                <option value="cheque">Cheque</option>
              </select>

              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Bank Name" formControlName="bank">
              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Branch Name"
                formControlName="branch">
              <label class="cheque-mode">Date of cheque</label>
              <input type="date" class="form-control mb-2 cheque-mode" formControlName="date_of_checque">
              <label class="cheque-mode">Upload Image*</label>
              <label class="neft-mode">Upload Image</label>
              <input type="file" class="form-control cheque-mode" formControlName="image" (change)="onChange($event)">
              <input type="file" style="margin-bottom: 1rem" class="form-control neft-mode" formControlName="image"
                (change)="onChange($event)">
              <label class="neft-mode">Transaction Number</label>
              <input type="text" class="form-control mb-2 neft-mode" placeholder="Enter Transaction Number" formControlName="transaction_number">
              <label class="neft-mode">Payment Date</label>
              <input type="date" class="form-control mb-2 neft-mode" formControlName="date">
              <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" (click)="savePayment()"
              [disabled]="!paymentForm.valid">Add Payment</button>
         
            </form>
            <pre>
            <!-- {{paymentForm.value | json}} -->
          </pre>
        </div>
          <div class="col-md-6">
            

          </div>


        </div>
          </div>
          <div class="tab-pane" [ngClass]="{
                              'active':
                               approvedBoqList.length > 0 
                            }" id="profileFortyHundered" role="tab_two">
            <div class="row">
              <div class="col-md-12">
            <form [formGroup]="sendpaymentForm" >
              <label >Enter Amount</label>
              <input type="text"  class="form-control mb-2" placeholder="Enter amount" formControlName="totalamount" appTwoDigitDecimaNumber [(ngModel)] ="totalAmount" onKeyPress="totalamount()"   >
              <p class="error" *ngIf="totalAmount > 5000000">Amount should not be more than 50 lakhs</p>
              <label >Email</label>
              <input type="text" class="form-control mb-2 " formControlName="email" [(ngModel)]="LeadNumber"  >
              <p class="error" *ngIf="sendpaymentForm.controls.email.touched && sendpaymentForm.controls.email.errors && sendpaymentForm.controls.email.errors.pattern">Please Enter Valid Email Address</p>
              <label >Mobile Number</label>
              <input type="number" class="form-control mb-2 " formControlName="mobilenumber" [(ngModel)]="LeadMail"  onKeyPress="if(this.value.length==10) return false;" >
              <p class="error" *ngIf="sendpaymentForm.controls.mobilenumber.touched && sendpaymentForm.controls.mobilenumber.errors && sendpaymentForm.controls.mobilenumber.errors.pattern">Mobile No Should be At Least 10 Characters</p>
            
                <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" 
                [disabled]="!sendpaymentForm.valid || totalAmount > 5000000" (click)="sendapaymentrequest(sendpaymentForm.value)">Send Payment Link / Map Payment</button>
            </form>
            </div>
            </div>

             
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- Modal end here -->


<!--Payment history modal starts-->
<div id="paymentHistoryModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="loading d-block justify-content-center" *ngIf="loader">
    <div class="spinner-border" style="color: #8d0528;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="modal-dialog modal-lg" style="max-width:90% ;">
    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Payments History</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change p-4">
        <div class="row">
          <div class="col-md-12 p-0">
            <table class="table">
              <thead class="ss-thead">
                <tr>
                  <th class="firstTh">Request ID</th>
                  <th scope="col">Linked BOQS</th>
                  <th scope="col">Raising Date</th>
                  <th scope="col">Expiration Date</th>
                  <th scope="col">Requested Amount</th>
                  <th scope="col">Status</th>
                  <th scope="col">Link</th>
                  <th scope="col">Cancel</th>
                  <th scope="col">Adjust</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="ss-tbody" *ngFor="let history of payment_details_Arr; let i = index;"  >
              <tr class="addCursor" style="box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);">
                <td class="capitalize">{{ history.id }}</td>
                <td>
                  <p class="mb-0" *ngFor = "let data of history.quotations ; let z = index">{{data.reference_number}}</p>
                </td>
                <td class="capitalize">
                  <span *ngIf="history.created_at">{{history.created_at |  date: 'dd/MM/yyyy' }}</span>
                </td>
                <td>{{convertDate(history.updated_at) | date: 'dd/MM/yyyy' }}</td>
                <td>{{history.amount | currency:'INR':true: '1.0-0' }}</td>
                <td class="capitalize"> {{history.finance_status}} </td>

                <ng-container>  <!-- copy cash free link -->
                  <td title="Cash Free Link">
                    <img style="width: 25px;" src="../../../../assets/img/payment-history/link.png" (click) = "copyPaymentLink(history.payment_request.payment_link)" *ngIf = "history.payment_request !== null && history.payment_request.payment_link !== null && history.mode_of_payment == 'cashfree' && history.finance_status !== 'Approved' &&  history.finance_status !='Rejected'  ">
                  </td>
                </ng-container>
                 <td><!-- Cancel Link -->
                   <img *ngIf ="history.finance_status == 'Pending' && history.payment_request !== null && history.payment_request.payment_link !== null " (click) = "cancelLinkInPaymentHistory(history.id)" src="../../../../assets/img/payment-history/close filled.png" style="width: 25px;">
                   <small class="text-danger" *ngIf =" history.finance_status === 'Rejected'" >Payment Link Cancelled</small>
                  </td>
                <td>   <!--  Adjust -->
                  <img class="cursor-pointer" *ngIf = "history.finance_status === 'Pending'" (click) = "PaymentHistoryAdjust(history.quotations,history,i)" style="width: 25px;" src="../../../../assets/img/payment-history/wallet.png">
                </td>
                <td (click)="toggleRow(history.id)">
                  <i class="fa fa-angle-up" style="font-size: 25px;cursor: pointer;" *ngIf="expansion == history.id"></i>
                  <i class="fa fa-angle-down"style="font-size: 25px;cursor: pointer;" *ngIf="expansion !== history.id"></i>
                </td>

                <td class="text-center dropdown" style="width:40px !important;display:inline-block;margin-top: 20px;">
                  <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                    role="button" aria-haspopup="true" aria-expanded="false"></i>
                  <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px; margin-left: -5rem; margin-top: -1rem;">
                    <a class="dropdown-item addCursor" data-target="#PaymentReceipt" (click) ="PaymentReceiptData(history.id,history,true)" data-toggle="modal">View Transaction Details</a>
                    <a *ngIf ="history.finance_status === 'Pending'" class="dropdown-item addCursor" data-target="#extreChequeDetails" (click) = "extraChequeDetails(history.quotations,history.id,history.amount, history.payment_stage )" data-toggle="modal">Add Cheque Details</a>
                    <a class="dropdown-item addCursor" data-toggle="modal" (click)="getReceipt('',history)">Download Billing Receipt</a>
                  </div>
                </td>
              </tr>
                <tr *ngIf="expansion == history.id">
                  <td colspan="10">
                    <div class="row">
                      <div class="col-3">
                        <p class="text-capitalize">Payment Mode: {{history.mode_of_payment}} </p>
                      </div>
                      <div class="col-3" *ngIf="history.mode_of_payment == 'NEFT/RTGS' || history.mode_of_payment == 'cashfree' || history.mode_of_payment == 'hdfc'">
                        <p>Transaction ID: {{history.transaction_number}}</p>
                      </div>
                      <div class="col-3">
                        <p>Transaction Date: {{history.updated_at  | date: 'dd/MM/yyyy' }}</p>
                      </div>
                      <div class="col-3">
                        <p>Finance Status: {{history.finance_status}} </p>
                      </div>
                      <div class="col-3">
                        <p>Verification Date: {{history.finance_approved_at   | date: 'dd/MM/yyyy' }}</p> 
                      </div>
                      <div class="col-3">
                        <p>Payment Amount: {{history.amount | currency:'INR':true: '1.0-0'}}</p> 
                      </div>
                      <ng-container *ngIf ="history.mode_of_payment=== 'cheque' ">
                        <div class="col-3"  >
                          <p>Cheque Number: {{history.cheque_number}} </p>
                        </div>
                        <div class="col-3">
                          <p>Cheque Date:{{history.date_of_checque | date: 'dd/MM/yyyy' }}
                            <a class="mx-3" *ngIf="history.mode_of_payment == 'cheque' && history.image !='/images/original/missing.png'"
                            href="{{ history.image }}" target="_blank"
                            style="color: #8F0020;font-size: 20px; vertical-align: middle;">
                            <img src="../../../../assets/img/payment-history/download.png" style="width: 30px;">
                          </a>
                          </p> 
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 not-found " *ngIf="payment_details_Arr && payment_details_Arr.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="PaymentReceipt" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog" style="max-width: 34%;">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" style="margin-left: 105px;">Download Billing Receipt</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="PaymentModalHide();">&times;</button>
      </div>
      <div class="modal-body">
        <form class="personal-data-form" [formGroup]="ReceiptForm">
          <div class="">
            <label class="d-flex">Customer Name:
              <input class="form-control" placeholder="Customer name" type="text" formControlName="customer_name"
                style="margin-left:7px;" readonly>
            </label>
          </div>
          <div class="">
            <label class="d-flex">Amount:
              <input class="form-control" placeholder="Amount" type="number" formControlName="amount"
                style="margin-left:37px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details">
            <!--  -->
            <label class="d-flex">Date:
              <input [owlDateTime]="dt8" [owlDateTimeTrigger]="dt8" placeholder="Enter Date" formControlName="date"
                class="form-control" style="margin-left:61px;" readonly>
              <owl-date-time #dt8 [pickerType]="'calendar'" disabled></owl-date-time>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'NEFT/RTGS'">
            <label class="d-flex">NEFT/RTGS Trx No:
              <input class="form-control" placeholder="RTGS Trx No" type="text" formControlName="rtgs_trx_no"
                style="margin-left:-10px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'hdfc'">
            <label class="d-flex">HDFC Trx No:
              <input class="form-control" placeholder="HDFC Trx No" type="text" formControlName="hdfc_tx_no" [(ngModel)] ="hdfctxno"
                style="margin-left:-10px;" readonly>
            </label>
          </div>
           <div class="" *ngIf="this.details && this.details.mode_of_payment == 'cashfree'">
            <label class="d-flex">Cash Free Trx No:
              <input class="form-control" placeholder="HDFC Trx No" type="text" formControlName="cashfree_tx_no"  [(ngModel)] ="cashtxno"
                style="margin-left:2px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'cheque'">
            <!--cheque  -->
            <label class="d-flex">Bank:
              <input class="form-control" placeholder="Bank" type="text" formControlName="bank"
                style="margin-left:58px;" readonly>
            </label>
            <!-- cheque -->
            <label class="d-flex">Branch:
              <input class="form-control" placeholder="Branch" type="text" formControlName="branch"
                style="margin-left: 45px;" readonly>
            </label>
          </div>
        </form>
        <div class="col-12 mt-5 text-right">
          <!-- <i class="fa fa-arrow-circle-down p-0 mr-4 addCursor" (click)="getReceipt('')" style="font-size: 24px"
            data-toggle="tooltip" title="Click Here To Download Payment Receipt."></i> -->
          <i class="fas fa-share addCursor" (click)="share('share')" style="font-size: 24px" data-toggle="tooltip"
            title="Click Here To Share Payment Receipt."></i>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Payment Maping -->
<div class="modal" id="paymentMapping">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Payment Maping</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" style="height:20rem; overflow:scroll">
        <div class="pt-2">
        </div>
        <div class="row mb-3">
          <div class="col-md-5 pt-2">
            <span>
              Unutilized Amount At
              <span *ngIf="selectedSet == 'pre_10_percent'">
                10%
              </span>

              <span *ngIf="selectedSet == 'order_pipe'">
                order pipeline
              </span>

              <span *ngIf="selectedSet == '10_50_percent'">
                40%
              </span>

              <span *ngIf="selectedSet == '100_percent'">
                50%
              </span>
            </span>
            :{{use_total_amt}}
          </div>
          <div class="col-md-2"><button class="btn btn-pink bt-boq" style="font-size: 14px;"
              (click)="mapProporitionately()">Map Proporitionately</button></div>
          <div class="col-md-2 pt-1"><input class="inputBorder clearamount" type="number" id="unutilizePayment"
              (input)="getUnutilAmount($event.target.value)" /></div>
          <div class="col-md-2 pt-1"><input class="inputBorder clearPerc" type="text" id="unutilizePercentage"
              value="0%" disabled /></div>
        </div>
        <ng-container *ngIf="selectedSet == 'pre_10_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container *ngIf="item.per_10_approved_at == null && item.per_10_closure_reported_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input class="inputBorder clearamount pl-1" type="number" id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" value=0 /></div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" id="boqPercent{{item.id}}"
                  value="0%" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf ="selectedSet ==   'order_pipe' ">
          <div class="row" *ngFor="let item of approveList">
            <ng-container *ngIf="item.per_10_approved_at == null && item.per_10_closure_reported_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input class="inputBorder clearamount pl-1" type="number" id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" value=0 /></div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" id="boqPercent{{item.id}}"
                  value="0%" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedSet == '10_50_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container *ngIf="item.per_50_push_to_production_reported_at == null && item.per_50_approved_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input class="inputBorder clearamount pl-1" type="number" id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" value=0 /></div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" value="0%"
                  id="boqPercent{{item.id}}" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedSet == '100_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container  *ngIf="item.per_100_reported_at == null && item.per_100_approved_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input placeholder="Enter Amount" class="inputBorder clearamount pl-1" type="number"
                  value=0 id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" />
              </div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" value="0%"
                  id="boqPercent{{item.id}}" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-pink bt-boq" (click)="submitMapPayment()">Submit</button>
      </div>
    </div>
  </div>
</div>

<!--Account Details Modal-->
<div id="accountDetailsModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <!-- <div class="vertical-alignment-helper"> -->
  <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
    <div class="modal-content modal-change">
      <div class="modal-header">
        <h4 class="modal-title">Account Details</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change p-4">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="row">   
              <div class="col-md-6">Customer Name:</div>
              <div class="col-md-6 detailscolor account_name mt-1" style="font-size: 13px;">{{accountdetails?.customer_name}}</div>
              </div>
         <div class="row">   
        <div class="col-md-6">Payment Mode:</div>
        <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.payment_mode}}</div>
        </div>
        <div class="row">   
          <div class="col-md-6">Account Name:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.account_name}}</div>
          </div>
          <div class="row">   
          <div class="col-md-6">Account Number:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.account_number}}</div>
          </div>  
          <div class="row">   
          <div class="col-md-6">IFSC Code:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.ifsc_code}}</div>
          </div> 
          <div class="row">   
            <div class="col-md-6">Bank And Branch:</div>
            <div class="col-md-6 detailscolor account_name mt-1">{{bankAndbrach}}</div>
            </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
</div>
<!--Account Details Modal Ends Here-->

<!-- The Closure Modal -->
<div class="modal" id="closureModal">
  <div class="modal-dialog" style="max-width: 40%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Report Order Pipeline</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to report order pipeline? The action can not be undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <!-- <button type="button" class="btn btn-success" data-dismiss="modal" (click)="closureBoq()" style="width: 67px;">Yes</button> -->
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="reportOrderPipeLine()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="ReportClouser">
  <div class="modal-dialog" style="max-width: 40%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Report Closure</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
       <div class="modal-body">
        Are you sure you want to report the closure?
      </div>
      <!-- <div class="modal-body" *ngIf="checkpaymentStatus(this.selectedBoqClosure) == true">
        Payment link is already shared with customer. If you click on the yes,
        the raised payment request will be cancelled and the closure will be done automatically.
      </div> -->

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="reportClosure()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="ApproveOrderPipeLineModel">
  <div class="modal-dialog" style="max-width: 40%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Report Order Pipeline</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to report order pipeline? The action can not be undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="reportForBuHead()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>


<!-- The Closure Modal -->
<div class="modal" id="reqpushToprobModal">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Push to production</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to ask for push to production? The action can not be undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="pushToproduction()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>

<div  class="modal fade" id="UnutilizedModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-backdrop="static" aria-hidden="true">
  <div class="modal-dialog w-50" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> -->
        <button type="button" class="close ml-auto"  aria-label="Close" (click) = "openpremodal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p *ngIf ="selectedSet == 'pre_10_percent' || selectedSet == 'order_pipe' " ><span class="font-weight-bold">Unmapped Amount Available:</span>₹{{ amountAdded_10 | number : '1.0-0'}}</p>
        <p *ngIf ="selectedSet == '10_50_percent'  || selectedSet == '100_percent' " ><span class="font-weight-bold">Unmapped Amount Available:</span>₹{{ amountAdded_40 | number : '1.0-0'}}</p>
        <p><span class="font-weight-bold">Total Payable:</span>₹{{ totalAmountsubUnUtilisied | number : '1.0-0' }}</p>
      </div>
      <div class="modal-footer justify-content-center border-0">
        <button style="width: unset;" (click) = "unutilizedAmountPresent()" type="button" class="btn  bt-boq">Send Payment Link / Map Payment</button>
        <button (click) = "openpremodal()" type="button" class="btn btn-secondary">Cancel Link</button>
      </div>
    </div>
  </div>
</div>

<div  class="modal fade" id="extreChequeDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-backdrop="static" aria-hidden="true">
  <div class="modal-dialog w-50" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Cheque Details</h5>
        <button type="button" class="close ml-auto"  aria-label="Close" (click) ="closeextraChequeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="paymentForm">
          <ng-container *ngIf="selectedSet != '100_percent'">
            <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Enter Paid Amount"
              formControlName="amount" readonly>
          </ng-container>
          <ng-container *ngIf="selectedSet == '100_percent'">
            <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Paid Amount"
              formControlName="amount" (input)="checkPendingAmt($event.target.id)">
          </ng-container>
          <select formControlName="mode_of_payment" class="form-control mb-2 d-none" (change)="changePaymentMode($event)">
            <option [selected]="true" value="cheque">Cheque</option>
          </select>
          <input type="text" class="form-control mb-2" placeholder="Bank Name" formControlName="bank">
          <input type="number" class="form-control mb-2" placeholder="Cheque Number" formControlName="cheque_number">
          <input type="text" class="form-control mb-2" placeholder="Branch Name" formControlName="branch">
          <label class="">Date of cheque</label>
          <input type="date" class="form-control mb-2" formControlName="date_of_checque">
          <label class="">Upload Image*</label>
          <input type="file" class="form-control" formControlName="image"  (change)="onChange($event)">         
          <label class="neft-mode">Payment Date</label>
          <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" (click)="savePayment()" [disabled]="!paymentForm.valid ||  (!basefile) ">Add Payment</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- The Final Payment selection-->
<div class="modal" id="finalpaymentselectionModel">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Final Payment Completion</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to ask for final payment completion? The action can not be undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="FinalPaymentSelectionYes()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="confirmRevert">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Confirm the Revert of Payment </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to revert the Final Payment 
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="revert_payment()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="on-hlodModal">
  <div class="modal-dialog" role="document" style="max-width: 65%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalReferencenumber}} On-Hold</h5>
        <button class="onholdModalButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form [formGroup] = "onHoldForBOQ" class="mx-5 mt-3" >
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-2 col-form-label">Date of Resume<span class="text-danger">*</span></label>
          <div class="col-sm-10">
            <!-- <input [min] = "yesterday" type="date" formControlName="onhold_resume_at"  class="form-control"> -->
            <!-- <input class="form-control" placeholder="dd/MM/yyyy" [min]="minDate" formControlName="onhold_resume_at"    [owlDateTimeTrigger]="dt" [owlDateTime]="dt"> -->

            <input  [owlDateTime]="dt2" formControlName="onhold_resume_at" [owlDateTimeTrigger]="dt2" placeholder="Select Date"
            class=" rk-form-fontsize d-block form-control rounded"
           [min]="minDate">
          <owl-date-time #dt2 [pickerType]="'calendar'"></owl-date-time>

          </div>
        </div>

        <!-- <textarea class="form-control" id="remarks" required name="remarks" formControlName="remarks"
        rows="4" cols="50">
        </textarea> -->

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label">Reason for Hold<span class="text-danger">*</span></label>
          <div class="col-sm-10">
            <input type="text" class="form-control" formControlName = "onhold_reason" id="inputPassword" placeholder="Enter Reason For Hold">
          </div>
        </div>

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label">Comments<span class="text-danger">*</span></label>
          <div class="col-sm-10">
            <input type="text" formControlName = "onhold_comment" class="form-control" id="inputPassword" placeholder="Enter Comments">
          </div>
        </div>

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label">Customer OTP<span class="text-danger">*</span></label>
          <div class="col-sm-10">
            <input type="text" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"   class="form-control" formControlName = "otp"  id="inputPassword" placeholder="Enter OTP">
          </div>
        </div>
        <div>
          <button class="onholdModalButton btn cursor-pointer" (click) ="resendOTP()" >Resend OTP</button>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <button  [disabled]="!onHoldForBOQ.valid"  class="onholdModalButton btn cursor-pointer " (click) = "onHoldSubmit()" >Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="un-holdmodal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalReferencenumber}} Un-Hold</h5>
        <button class="onholdModalButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  [formGroup] = "unholdboq" class="mx-5 mt-3" >
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-2 col-form-label">Customer OTP<span class="text-danger">*</span></label>
          <div class="col-sm-10">
            <input type="text" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" formControlName="otp"  class="form-control">
          </div>
        </div>

        <div>
          <button class="onholdModalButton btn cursor-pointer" (click) ="resendOTP()" >Resend OTP</button>
        </div>

        <div class="d-flex justify-content-center my-3">
          <button [disabled]="!unholdboq.valid"  class="onholdModalButton btn cursor-pointer" (click) = "boqunhold()" >Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal fade" id="subTableModal" tabindex="-1" role="dialog" aria-labelledby="subTableModal" aria-hidden="true">
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title heading" id="remarksModalLabel">On Hold Details</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <span>
        <table id="modalTable" class="w-100 mt-3">
          <thead>
            <tr>
              <th>On Hold Date</th>
              <th>Reason For Hold</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor ="let data of HoldDetails; let z=index">
                <td>{{data.onhold_resume_at | date:'dd/MM/yyyy'}}</td>
                <td>{{data.onhold_reason}}</td>
                <td style="width: 250px;">{{data.onhold_comment}} 
                </td>
              </tr>
          </tbody>
        </table>
      </span>
    </div>
  </div>
</div>
</div>
<div class="loading d-block justify-content-center" *ngIf="loader">
  <div class="spinner-border" style="color: #8d0528;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- Modal to confirm revert payment-->
<div class="modal" id="confirmRevert">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Confirm the Revert of Payment </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to revert the Final Payment 
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="revert_payment()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="confirmP2P">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Confirm the Push to Production </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to Push to Production ?
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="jubrunFortyApprove(p2p_id)" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="confirmP2PApprove">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Confirm the Approve Push to Production </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to Approve Push to Production ?
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="approve40PaymentSelection(p2p_id)" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for push to production adress details -->
<div class="modal" id="pushToprodModal">
  <div class="loading d-block justify-content-center" *ngIf="loader">
    <div class="spinner-border" style="color: #8d0528;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="modal-dialog" style="max-width: 70%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Add Payment Address</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <!-- addUserFrom.reset() -->
        <form [formGroup]="addUserFrom" (ngSubmit)="onSubmit(addUserFrom.value)">
          <fieldset formGroupName="shippingAddressGroup">
            <div class="row">
              <div class="col-12">
                Shipping Address
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">First Name<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="first_name" formControlName="first_name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Last Name<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="last_name" formControlName="last_name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Email<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="email" formControlName="email">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Phone<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="phone" formControlName="phone">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Company</label>
                  <input type="text" class="form-control selectStyle1" id="company" formControlName="company">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Address1<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="address1" formControlName="address1">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Address2</label>
                  <input type="text" class="form-control selectStyle1" id="address2" formControlName="address2">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">City<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="city" formControlName="city">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">State Or Province<span class="astric">*</span></label>
                  <!-- <input type="text" class="form-control selectStyle1" id="state_or_province" formControlName="state_or_province"> -->
                  <select formControlName="state_or_province" class="form-control selectStateStyle mb-2" (change)="selectState($event)">
                    <option value="" [selected]="true" disabled="true">Select State Or Province</option>
                    <option *ngFor="let data of stateList" value="{{data.name}}">{{data.name}}</option>
                  </select>
                </div>
              </div>
              <ng-container *ngIf="stateCode">
                <div class="col-md-6">
                  <div class="form-group label-floating">
                    <label class="control-label labelStyle">State Or Province Code</label>
                    <input type="text" class="form-control selectStyle1" id="state_or_province_code" disabled [value]="stateCode" formControlName="state_or_province_code">
                  </div>
                </div>
              </ng-container>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Country Code<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="country_code" formControlName="country_code">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Postal Code<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="postal_code" formControlName="postal_code">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">GSTIN</label>
                  <input type="text" class="form-control selectStyle1" id="gstin" formControlName="gstin">
                </div>
              </div>
            </div>
          </fieldset>
          <!-- <div class="col-md-12 mt-2 pl-0">
            <div class="form-group">
              <label class="ss-form-label">
                <input id="addId" type="checkbox" name="checkAddress" class="activeRMStyle mr-2"
                  (change)="handleAddresscheck($event)">
                Billing address is same as shipping address
              </label>
            </div>
          </div> -->
          <!-- <fieldset formGroupName="billingAddressGroup" [disabled]="sameAddress" *ngIf="!this.sameAddress"></fieldset> -->
          <fieldset formGroupName="billingAddressGroup">
            <div class="row">
              <div class="col-12">
                Billing Address
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">First Name<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="first_name" disabled formControlName="first_name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Last Name<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="last_name" disabled formControlName="last_name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Email<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="email" disabled formControlName="email">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Phone<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="phone" disabled formControlName="phone">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Company</label>
                  <input type="text" class="form-control selectStyle1" id="company" disabled formControlName="company">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Address1<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="address1" disabled formControlName="address1">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Address2</label>
                  <input type="text" class="form-control selectStyle1" id="address2" disabled formControlName="address2">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">City<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="city" disabled formControlName="city">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">State Or Province<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="state_or_province" disabled formControlName="state_or_province">
                  <!-- <select formControlName="state_or_province" class="form-control selectStateStyle mb-2" (change)="selectState2($event)">
                    <option value="" [selected]="true" disabled="true">Select State Or Province</option>
                    <option *ngFor="let data of stateList" value="{{data.name}}">{{data.name}}</option>
                  </select> -->
                </div>
              </div>
              <!-- <ng-container *ngIf="stateCode"> -->
                <div class="col-md-6">
                  <div class="form-group label-floating">
                    <label class="control-label labelStyle">State Or Province Code<span class="astric">*</span></label>
                    <input class="form-control selectStyle1" id="state_or_province_code" disabled [value]="stateCode2" formControlName="state_or_province_code">
                  </div>
                </div>
              <!-- </ng-container> -->
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Country Code<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="country_code" disabled formControlName="country_code">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">Postal Code<span class="astric">*</span></label>
                  <input type="text" class="form-control selectStyle1" id="postal_code" disabled formControlName="postal_code">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group label-floating">
                  <label class="control-label labelStyle">GSTIN</label>
                  <input type="text" class="form-control selectStyle1" id="gstin" disabled formControlName="gstin">
                </div>
              </div>
            </div>
          </fieldset>

          <div class="col-md-12 buttonCol">
            <button type="submit" class="pull-right submitBtn" [disabled]="addUserFrom?.invalid">Submit</button>
            <!-- <p (click)="pushJobAttributes(createPortfolioForm)" class="addIcon addNewStyle px-5 py-4"><span class="btnIconStyle">+</span> Add New</p> -->
          </div>
        </form>
      </div>

      <!-- Modal footer -->
      <!-- <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="FinalPaymentSelectionYes()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div> -->
    </div>
  </div>
</div>
<!-- Modal for push to production adress details -->


// WEBPACK FOOTER //
// ./src/app/platform/lead/payments/payments.component.html